import { withInstall } from '../../../../utils/with-install'
import IndoorMap from './IndoorMap.vue'

export const ElAmapLayerIndoorMap = withInstall(IndoorMap)
export default ElAmapLayerIndoorMap
